package fr.labodoc.healthProfessional.webApp.data.model

import fr.labodoc.domain.labodoc.common.NotificationFrequency
import kotlinx.datetime.Instant

data class HealthProfessionalUserModel(
  val emailAddress: String,
  val lastLoginDate: Instant?,
  val rppsNumber: String?,
  val firstName: String,
  val lastName: String,
  val department: Department,
  val medicalProfession: MedicalProfession?,
  val medicalSpeciality: MedicalSpeciality?,
  val medicalInterests: Set<MedicalInterest>,
  val canHaveMedicalInterests: Boolean,
  val professionalCategory: ProfessionalCategory,
  val professionalStatus: ProfessionalStatus?,
  val notificationFrequency: NotificationFrequency?
) {
  data class Department(
    val code: String,
    val name: String
  )

  data class MedicalProfession(
    val id: String,
    val name: String
  )

  data class MedicalSpeciality(
    val id: String,
    val name: String
  )

  data class MedicalInterest(
    val id: String,
    val name: String
  )

  data class ProfessionalCategory(
    val code: String,
    val name: String
  )

  data class ProfessionalStatus(
    val code: String,
    val name: String
  )
}
